import { StyledScimProvisioning } from './ScimProvisioning.style';
import ScimStatusBar from '../../../components/SettingStatusBar/status-bars/ScimStatusBar';

const Loader = () => {
  return (
    <StyledScimProvisioning>
      <ScimStatusBar isLoading={true} />
    </StyledScimProvisioning>
  );
};

export default Loader;
